import type { QuoteDocument } from 'paintscout'

/**
 * Whether a payment collected directly on this quote (no request, no invoice) can still be "the
 * deposit" — only true before an invoice exists and before a deposit has already landed. Shared by
 * every site that computes a payment's `deposit` flag (ConfigurePaymentDialog, the customer-view
 * main-nav Pay button) so the rule can't drift out of sync between them again — see
 * docs/flows/payment-processing-flow.md's `allowQuotePayments` gotcha for the history here.
 */
export function isEligibleForQuoteDeposit(quote: Pick<QuoteDocument, 'is_invoice' | 'depositInfo'>): boolean {
  return !quote?.is_invoice && !quote?.depositInfo
}
